import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCogs,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import { DropdownButton, Dropdown, ButtonGroup } from "react-bootstrap";
import axios from "axios";
import Moment from "react-moment";
import "moment/locale/es-mx"

export default class ReportePDF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      existe: false,
      nombre_archivo: "",
      fecha: "",
      regenera: false,
      contador: 0,
    };
  }

  componentDidMount() {

  }

  checaRegenera = () => {
    let contador = this.state.contador + 1
    if (contador == 10 && this.state.regenera) {
      this.existeFnc()
      contador = 0
    }
    this.setState({ contador: contador })
  }

  existeFnc = () => {
    this.setState({ contador: 0 })
    axios({
      method: "get",
      url:
        "http://143.198.191.211/pdf/existe/" +
        "?f=" +
        this.props.anexo +
        "&a=" +
        this.props.ambito_id +
        "&api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({
        regenera: res.data.regenera,
        existe: res.data.existe,
        nombre_archivo: res.data.nombre_archivo,
        fecha: res.data.fecha
      })
    })
  }

  abre_link = () => {
    let href = "http://143.198.191.211/pdf/?a=" + this.props.ambito_id + "&f=" + this.props.anexo
    window.open(href, "_blank")
  }

  regeneraBtn = () => {
    this.setState({ regenera: true, existe: false, contador: 0 })
    axios({
      method: "get",
      url:
        "http://143.198.191.211/pdf/" +
        "?c=97sgJjUr" +
        "&f=" +
        this.props.anexo +
        "&a=" +
        this.props.ambito_id +
        "&api_token=" +
        localStorage.api_token,
      data: {},
    })
  }

  render() {
    return (
      <DropdownButton as={ButtonGroup}
        style={this.props.style}
        onClick={() => this.existeFnc()}
        title={<span><FontAwesomeIcon
          icon={faFilePdf} /> Descargar PDF</span>}>
        {this.state.existe ?
          <Dropdown.Item
            eventKey="1"
            onClick={this.abre_link}
            data-tip={"Descarga PDF anexo " + this.props.anexo + " ámbito " + this.props.ambito_id + " (Generado el " + this.state.fecha + ")"}
            style={{
              textAlign: "center"
            }}>
            <FontAwesomeIcon icon={faFilePdf} /> Descargar PDF
            <br></br>
            (Generado {" "}
            <Moment interval={30000} calendar locale="es-mx">
              {this.state.fecha}
            </Moment>
            )
          </Dropdown.Item>
          :
          null
        }
      </DropdownButton >
    );
  }
}
